import { render, staticRenderFns } from "./64qyji.vue?vue&type=template&id=51aea413&"
import script from "./64qyji.vue?vue&type=script&lang=js&"
export * from "./64qyji.vue?vue&type=script&lang=js&"
import style0 from "./64qyji.vue?vue&type=style&index=0&id=51aea413&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports